import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_COLUMNS_SETTINGS: GlameraIconDefinition = {
  name: 'columns-settings',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-columns-settings-panel" d="M10.5 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v5.5"></path>
    <path class="glm-columns-settings-divider glm-columns-settings-divider-left" d="M9 3v18"></path>
    <path class="glm-columns-settings-divider glm-columns-settings-divider-right" d="M15 3v7.5"></path>
    <g class="glm-columns-settings-gear">
      <path d="m14.3 19.6 1-.4"></path>
      <path d="m15.2 16.9-.9-.3"></path>
      <path d="m16.6 21.7.3-.9"></path>
      <path d="m16.8 15.3-.4-1"></path>
      <path d="m19.1 15.2.3-.9"></path>
      <path d="m19.6 21.7-.4-1"></path>
      <path d="m20.7 16.8 1-.4"></path>
      <path d="m21.7 19.4-.9-.3"></path>
      <circle cx="18" cy="18" r="3"></circle>
    </g>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-columns-settings-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './columns-settings.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ColumnsSettingsIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_COLUMNS_SETTINGS;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
